import { useMemo } from 'react';

import { DROPDOWN_FETCH_PAGE_SIZE } from '@klareospace/pharos-lib-front-utils';
import type { Carrier } from '@klareospace/pharos-lib-types';
import type { MultiSelectOption } from '@klareospace/pharos-lib-web-utils';

import { useCarriers } from './use-carriers';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseCarriersForSelectOptions {
  enabled?: boolean;
  enabledOnSiteId?: string;
  spaceId?: string;
  /** Which carrier field to use as the option value — defaults to 'id' (task-assignment usage). */
  valueKey?: 'id' | 'code';
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useCarriersForSelect(options?: UseCarriersForSelectOptions): MultiSelectOption[] {
  const { enabled = true, enabledOnSiteId, spaceId, valueKey = 'id' } = options ?? {};
  const { data } = useCarriers({ enabledOnSiteId, enabled, page: 1, pageSize: DROPDOWN_FETCH_PAGE_SIZE, spaceId });

  return useMemo(
    () => (data?.items ?? []).map((carrier: Carrier) => ({ label: carrier.name, value: carrier[valueKey] })),
    [data, valueKey],
  );
}
